import { queryAvailability as bookingsQueryAvailability } from '@wix/ambassador-bookings-availability-v1-slot-availability/http';
export const queryAvailability = async _ref => {
  let {
    httpClient,
    errorHandler,
    request
  } = _ref;
  try {
    const response = await errorHandler.withErrorHandler(() => httpClient.request(bookingsQueryAvailability(request)), {
      errorCodesMap: {}
    });
    return response == null ? void 0 : response.data;
  } catch (e) {
    const resolvedError = errorHandler.getResolvedError(e);
    console.error(resolvedError);
    return undefined;
  }
};
//# sourceMappingURL=query-availability.js.map